import script from "./WptService.vue?vue&type=script&setup=true&lang=js"
export * from "./WptService.vue?vue&type=script&setup=true&lang=js"

import "./WptService.vue?vue&type=style&index=0&id=08f17889&lang=css"

const __exports__ = script;

export default __exports__